import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwActionItemRequirement, DwMdFormActionHandler, DwMdFormActionState } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaData, AppMetaDataItemNames, AssignmentStudentEntity, CourseEntity, StudentCourseEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { CourseProgressVariableContext } from "../models/course-progress-variable-context.model";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";
import { SchoolRepositoryService } from "../../schools/services/school-repository.service";
import { CourseRepositoryService } from "../services/course-repository.service";

@DwAction({
    keyName: 'course-update-time',
    display: 'Course - Update Total Time',
    actionType: DwActionType.formAction,
    parentItemName: AppMetaDataItemNames.Course,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Update Course Time',
        iconClass: 'fa fa-clock',
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Updates the total time required for a course'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: AppPermissions.contentAdmin,
        requireCanUpdate: true
    },
    defaultConfirmConfig :{
        showDialogConfig: true,
        showConfirmDialog: true,
        message: 'Are you sure?  This will update the total time required for the course and modules!',
        title: 'Update Course Time'
    }
})
@Injectable()
export class CourseTotalTimeUpdateActionService implements DwMdFormActionHandler {
    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        @Optional() private dwFormStateService: DwMetaDataFormStateService,
        private courseRespositoryService: CourseRepositoryService,
        private dwEventService: DwEventService
    ) {
        
    }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        const result: DwActionResult = {
            success: false,
            
        };
        const course = actionState.formApi.getFormData<CourseEntity>();

        if (!course.CourseId) {
            result.cancelled = true;
            return of(result);
        }

        return this.courseRespositoryService.updateCourseTotalTime(course.CourseId)
            .pipe(map((resetResult) => {
                const result: DwActionResult = {
                    success: resetResult.IsSuccess,
                };

                if (resetResult.ErrorMessage) {
                    result.message = `Error updating total course time  Error: ${resetResult.ErrorMessage} `
                } else {
                    if (resetResult.ChangesMade) {
                        result.message = 'Course and Module Total Time has been updated';
                    } else {
                        result.message = 'Course and Module Total Time was already up to date';
                    }
                }
        
                return result;
            }));
    }
}